import { ILoginResponse } from "@faire/web-api/indigofair/data/ILoginResponse";
import { ISignUpSuggestions } from "@faire/web-api/indigofair/data/ISignUpSuggestions";
import { IUser } from "@faire/web-api/indigofair/data/IUser";
import { Column, HorizontalLine, Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

import { AppleLoginButton } from "@faire/retailer/components/SocialSignOnButtons/AppleLoginButton";
import { GoogleLoginButtonV2 } from "@faire/retailer/components/SocialSignOnButtons/GoogleLoginButtonV2";

interface IProps {
  onSignIn: (user: IUser) => void;
  onMFA: (mfaDescription: string, mfaTitle: string) => void;
  onSelectMFA: (mfaOptions: ILoginResponse.IMfaOption[]) => void;
  onConfirmPassword: (signUpSuggestions?: ISignUpSuggestions) => void;
  sourceId: string;
  hideApple?: boolean;
  disabled?: boolean;
  separatorPosition?: "none" | "above" | "below";
  isOnSignIn?: boolean;
}

export const SocialSignOnButtons: React.FC<IProps> = ({
  onSignIn,
  onMFA,
  onSelectMFA,
  onConfirmPassword,
  hideApple,
  disabled,
  separatorPosition = "above",
  isOnSignIn,
  sourceId,
}) => {
  const spacing = <Spacer height="2x" />;

  const separator = (
    <>
      <Row align="center">
        <HorizontalLine />
        <Spacer width="2x" />
        <Typography>
          <StrictLocalMsg
            defaultMessage="or"
            description={{ text: "Use 'this' or 'that'" }}
          />
        </Typography>
        <Spacer width="2x" />
        <HorizontalLine />
      </Row>
    </>
  );

  return (
    <Column style={{ width: "100%" }}>
      {separatorPosition === "above" ? (
        <>
          {spacing}
          {separator}
          {spacing}
        </>
      ) : null}
      <GoogleLoginButtonV2
        onSignIn={onSignIn}
        onSelectMFA={onSelectMFA}
        onMFA={onMFA}
        onConfirmPassword={onConfirmPassword}
        disabled={disabled}
        isOnSignIn={isOnSignIn}
        sourceId={sourceId}
      />

      {hideApple ? null : (
        <>
          <Spacer height="2x" />
          <AppleLoginButton
            onSignIn={onSignIn}
            onSelectMFA={onSelectMFA}
            onMFA={onMFA}
            onConfirmPassword={onConfirmPassword}
            disabled={disabled}
            isOnSignIn={isOnSignIn}
            sourceId={sourceId}
          />
        </>
      )}
      {separatorPosition === "below" ? (
        <>
          {spacing}
          {separator}
          {spacing}
        </>
      ) : null}
    </Column>
  );
};
